/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { LEAD_MEDIUM } from 'domain/sales/lead/shared/leadService';

const LeadMediumField = ({ value: inputValue = null, source = null }: FieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source));

  return <EnumField label="Lead medium" value={value} options={LEAD_MEDIUM} />;
};

export default LeadMediumField;
